import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeSelector = () => {
  const { theme, themes, updateTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const themeOptions = [
    { key: 'ocean', name: 'Ocean', icon: '🌊' },
    { key: 'sunset', name: 'Sunset', icon: '🌅' },
    { key: 'forest', name: 'Forest', icon: '🌲' },
    { key: 'midnight', name: 'Midnight', icon: '🌙' }
  ];

  const currentTheme = themeOptions.find(t => t.key === theme);

  return (
    <div className="relative">
      <button
        id="theme-selector"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label={`Current theme: ${currentTheme?.name || 'Ocean'}. Click to change theme.`}
        className="flex items-center space-x-2 px-3 py-2 rounded-lg border theme-border hover:theme-border-secondary transition-colors"
      >
        <span className="text-2xl" aria-hidden="true">{currentTheme?.icon}</span>
        <span className="text-sm font-medium theme-primary">{currentTheme?.name}</span>
        <svg className="w-4 h-4 transition-transform theme-secondary" style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} aria-hidden="true">
          <path fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7 7" />
          </path>
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-48 theme-bg rounded-lg shadow-lg border theme-border-secondary z-50" role="listbox" aria-label="Theme options">
          <div className="py-1">
            {themeOptions.map((option) => (
              <button
                key={option.key}
                role="option"
                aria-selected={theme === option.key}
                onClick={() => {
                  updateTheme(option.key);
                  setIsOpen(false);
                }}
                aria-label={`Select ${option.name} theme`}
                className={`w-full text-left px-4 py-2 text-sm hover:theme-bg-secondary flex items-center space-x-3 ${
                  theme === option.key ? 'theme-bg-secondary theme-accent' : 'theme-primary'
                }`}
              >
                <span className="text-xl" aria-hidden="true">{option.icon}</span>
                <span>{option.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThemeSelector;
